import { HealthSeverity } from '@shure/shared/angular/data-access/system-api/models';

export const UNGROUPED_GROUP_ID = 'ungrouped';

export interface Group {
	id: string;
	name: string;
	parentId?: string;
	health: {
		worstSeverity?: HealthSeverity;
	};
}
